import { getSampleArrayFromSever } from "@/views/WorkSheet/xml-manager";

export const workSheetGetters = {
    workSheetList: state => state.workSheet.workSheetList,  
    infoList: state => {
        var list = state.workSheet.infoList
        list.forEach(element => {
            element.sample = getSampleArrayFromSever({sample:element.sample})
        });
  
        return list;
    }, 
    typeList:state => state.workSheet.typeList,  
    infotypeList:state => state.workSheet.infotypeList,  
    statusList:state => state.workSheet.statusList,  
    groupUserList:state => state.workSheet.groupUserList,  
    gradeList:state => state.workSheet.gradeList,  
    cate21VList:state => state.workSheet.cate21VList,  
    AnalisysSurveyRate:state=>{
        // console.log('aaa',state.analysis);
        const AnalisysSurveyRate = state.workSheet.AnalisysSurveySet[0] ?? [];
        return AnalisysSurveyRate;
    },
    AnalisysSurveyEach:state=>{
        //console.log('aaa',state.workSheet.AnalisysSurveySet);
        const AnalisysSurveyEach = state.workSheet.AnalisysSurveySet[1] ?? [];
        return AnalisysSurveyEach;
    },
    AnalisysSurveyList:state=>{
        // console.log('aaa',state.analysis);
        const AnalisysSurveyList = state.workSheet.AnalisysSurveySet[2] ?? [];
        return AnalisysSurveyList;
    },
    // GetWorkSheetDetail_Advance:state => state.workSheet.GetWorkSheetDetail_Advance,  
    GetWorkSheetDetail_Advance_main:state=>{
        console.log('aaabbb',state.workSheet.GetWorkSheetDetail_Advance);
        const GetWorkSheetDetail_Advance_main = state.workSheet.GetWorkSheetDetail_Advance[0] ?? [];
        return GetWorkSheetDetail_Advance_main;
    },
    GetWorkSheetDetail_Advance_toUIds:state=>{
        console.log('aaaccc',state.workSheet.GetWorkSheetDetail_Advance);
        const GetWorkSheetDetail_Advance_toUIds = state.workSheet.GetWorkSheetDetail_Advance[1] ?? [];
        return GetWorkSheetDetail_Advance_toUIds;
    },
    renewLogList:state => state.workSheet.renewLogList,
    importRenewOrderExcel2Tmp:state => state.workSheet.importRenewOrderExcel2Tmp,
    renewOrderList:state => state.workSheet.renewOrderList,
    // sheetCode:state => state.workSheet.sheetCode,  
};
